import React from 'react'
import { Button, Modal, Segment } from 'semantic-ui-react'

import { tr } from '../../helpers/languages'

const LogoutConfirmation = (props) => {
    return (
        <Modal className='logout' open onClose={(_e) => { props.onClose() }}>
            <Modal.Content>
                <Segment className='logout-title'>
                    {tr('WARNING')}
                </Segment>
                <Segment className='logout-text'>
                    {tr('LOGOUT_CONFIRMATION_TEXT')}
                </Segment>
                <Segment className='logout-buttons right aligned'>
                    <Button className='cancel-changes' onClick={(_e) => { props.onCancelChanges() }}>
                        {tr('NO')}
                    </Button>
                    <Button className='save-changes' onClick={(_e) => { props.onSaveChanges() }}>
                        {tr('YES')}
                    </Button>
                </Segment>
            </Modal.Content>
        </Modal>
    )
}

export default LogoutConfirmation



// WEBPACK FOOTER //
// ./src/components/logout-confirmation/index.js